export abstract class BaseComponent<TProps extends Record<string, any>> {
  abstract getProp<K extends keyof TProps>(
    prop: K,
  ): TProps[K] | null | undefined | void;

  abstract setProp<K extends keyof TProps>(
    prop: K,
    value: TProps[K] | null | undefined,
  ): void;

  abstract type: string | null;
}
